import { Component, Inject } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { MaintenanceModeService } from '../../services/http/maintenanceMode.service';
import { MaintenanceModeDateTimePipe } from "../../pipes/maintenanceModeDateTime.pipe";
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'maintenance-mode-banner',
  templateUrl: './maintenance-mode-banner.component.html',
  styleUrls: ['./maintenance-mode-banner.component.scss'],
  imports: [MaintenanceModeDateTimePipe, NgIf],
})
export class MaintenanceModeBannerComponent  {
  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    public maintenanceModeService: MaintenanceModeService
  ) { }
}